import { FC } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import { IEmailMessage, SendMessageStateEnum } from 'shared/models/Message'
import {
  SEND_EMAIL_REQUESTED,
  SEND_EMAIL_CLOSE,
} from 'shared/store/sendMessage/email/actionTypes'
import { getSendEmail } from 'shared/store/sendMessage/email/selectors'
import SendEmailLoading from './SendEmailLoading'
import SendEmail from './SendEmail'
import MessageReciept from './MessageReciept'
import { getSendSms } from 'shared/store/sendMessage/sms/selectors'
import SendSms from './SendSms'
import {
  SEND_SMS_CLOSE,
  SEND_SMS_REQUESTED,
} from 'shared/store/sendMessage/sms/actionTypes'
import { MessageTypes } from 'Modules/Communication/shared/models/Inbox'

const SendMessageHandler: FC = () => {
  const { state: emailState, loading: emailLoading } =
    useAppSelector(getSendEmail)
  const { state: smsState } = useAppSelector(getSendSms)
  const dispatch = useAppDispatch()
  if (!emailState && !smsState) return null

  const handleEmailAction = (message: IEmailMessage, messageId: string) =>
    dispatch({ type: SEND_EMAIL_REQUESTED, payload: { message, messageId } })

  const handleSmsAction = (message: string, messageId: string) =>
    dispatch({ type: SEND_SMS_REQUESTED, payload: { message, messageId } })

  const closeModal = (type: MessageTypes) => () =>
    type === 'email'
      ? dispatch({ type: SEND_EMAIL_CLOSE })
      : dispatch({ type: SEND_SMS_CLOSE })

  if (emailLoading) return <SendEmailLoading onClose={closeModal('email')} />

  return (
    <div>
      {emailState === SendMessageStateEnum.send && (
        <SendEmail onClose={closeModal('email')} onSend={handleEmailAction} />
      )}
      {emailState === SendMessageStateEnum.reciept && (
        <MessageReciept onClose={closeModal('email')} />
      )}

      {smsState === SendMessageStateEnum.send && (
        <SendSms onClose={closeModal('sms')} onSend={handleSmsAction} />
      )}
      {smsState === SendMessageStateEnum.reciept && (
        <MessageReciept onClose={closeModal('sms')} isSms />
      )}
    </div>
  )
}

export default SendMessageHandler
